import { StyleSheet } from "react-native";

export default StyleSheet.create({
  mainContainer: {
    width: '100%',

  },
  itemView: {
    paddingLeft: 10,
    width: '100%',

  },
  HoveredItemView: {
    paddingLeft: 10,
    width: '100%',
    backgroundColor: '#ed705b',
  },
  selectedBtn: {
    flexDirection: "row"
  },

  selectedValueStyle: {
    fontSize: 12,
    color: 'black',

  },

  touchableOpacityDropDownList: {
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    flexDirection: 'row',
    padding: 1,



  },
  dropDownImage: {
    height: 15,
    width: 15,
    marginRight: 10,
  },

  dropDownArrow: {
    height: 15,
    width: 15,
  },
  txtValue: {
    fontSize: 10,
  },
  txtValueHovered: {
    fontSize: 12,
    color: 'white',
  },
  popUp: {
    width: '100%',
    padding: 2,
    backgroundColor: "#ffffff",
    borderWidth: 1,
    borderColor: 'grey',
    borderStyle: 'solid',
    width: '100%',
    position: "absolute",
    zIndex: 1000,
    marginTop: 38,
  }
});
